export const NO_WAGE_TAX = new Set(["AK", "FL", "NV", "NH", "SD", "TN", "TX", "WA", "WY"]);
export const LOCAL_TAX = new Set(["AL", "CO", "DE", "IN", "KY", "MD", "MI", "MO", "NJ", "NY", "OH", "OR", "PA", "WV"]);
export const PAID_LEAVE = new Set(["CA", "CO", "CT", "DC", "DE", "HI", "MA", "ME", "MN", "NJ", "NY", "OR", "RI", "WA"]);

export const REGIONS = {
  Northeast: ["CT", "ME", "MA", "NH", "RI", "VT", "NJ", "NY", "PA"],
  Midwest: ["IL", "IN", "MI", "OH", "WI", "IA", "KS", "MN", "MO", "NE", "ND", "SD"],
  South: ["DE", "DC", "FL", "GA", "MD", "NC", "SC", "VA", "WV", "AL", "KY", "MS", "TN", "AR", "LA", "OK", "TX"],
  West: ["AZ", "CO", "ID", "MT", "NV", "NM", "UT", "WY", "AK", "CA", "HI", "OR", "WA"],
};

export const STATES = {
  AL: ["Alabama", ["Birmingham", "Huntsville", "Montgomery", "Mobile"]],
  AK: ["Alaska", ["Anchorage", "Fairbanks", "Juneau"]],
  AZ: ["Arizona", ["Phoenix", "Tucson", "Mesa", "Scottsdale"]],
  AR: ["Arkansas", ["Little Rock", "Fayetteville", "Bentonville", "Fort Smith"]],
  CA: ["California", ["Los Angeles", "San Diego", "San Jose", "San Francisco", "Sacramento"]],
  CO: ["Colorado", ["Denver", "Colorado Springs", "Aurora", "Fort Collins"]],
  CT: ["Connecticut", ["Stamford", "Hartford", "New Haven", "Bridgeport"]],
  DE: ["Delaware", ["Wilmington", "Dover", "Newark"]],
  DC: ["Washington, DC", ["Washington"]],
  FL: ["Florida", ["Miami", "Orlando", "Tampa", "Jacksonville"]],
  GA: ["Georgia", ["Atlanta", "Alpharetta", "Savannah", "Augusta"]],
  HI: ["Hawaii", ["Honolulu", "Hilo", "Kailua"]],
  ID: ["Idaho", ["Boise", "Meridian", "Nampa", "Idaho Falls"]],
  IL: ["Illinois", ["Chicago", "Naperville", "Aurora", "Springfield"]],
  IN: ["Indiana", ["Indianapolis", "Carmel", "Fort Wayne", "Evansville"]],
  IA: ["Iowa", ["Des Moines", "Cedar Rapids", "Davenport", "Iowa City"]],
  KS: ["Kansas", ["Wichita", "Overland Park", "Kansas City", "Topeka"]],
  KY: ["Kentucky", ["Louisville", "Lexington", "Bowling Green"]],
  LA: ["Louisiana", ["New Orleans", "Baton Rouge", "Shreveport", "Lafayette"]],
  ME: ["Maine", ["Portland", "Lewiston", "Bangor"]],
  MD: ["Maryland", ["Baltimore", "Columbia", "Rockville", "Frederick"]],
  MA: ["Massachusetts", ["Boston", "Cambridge", "Worcester", "Springfield"]],
  MI: ["Michigan", ["Detroit", "Grand Rapids", "Ann Arbor", "Lansing"]],
  MN: ["Minnesota", ["Minneapolis", "Saint Paul", "Rochester", "Bloomington"]],
  MS: ["Mississippi", ["Jackson", "Gulfport", "Southaven", "Hattiesburg"]],
  MO: ["Missouri", ["Kansas City", "St. Louis", "Springfield", "Columbia"]],
  MT: ["Montana", ["Billings", "Missoula", "Bozeman", "Helena"]],
  NE: ["Nebraska", ["Omaha", "Lincoln", "Bellevue"]],
  NV: ["Nevada", ["Las Vegas", "Henderson", "Reno"]],
  NH: ["New Hampshire", ["Manchester", "Nashua", "Concord"]],
  NJ: ["New Jersey", ["Newark", "Jersey City", "Edison", "Princeton"]],
  NM: ["New Mexico", ["Albuquerque", "Santa Fe", "Las Cruces"]],
  NY: ["New York", ["New York City", "Buffalo", "Rochester", "Albany"]],
  NC: ["North Carolina", ["Charlotte", "Raleigh", "Durham", "Greensboro"]],
  ND: ["North Dakota", ["Fargo", "Bismarck", "Grand Forks"]],
  OH: ["Ohio", ["Columbus", "Cleveland", "Cincinnati", "Dayton"]],
  OK: ["Oklahoma", ["Oklahoma City", "Tulsa", "Norman"]],
  OR: ["Oregon", ["Portland", "Salem", "Eugene", "Bend"]],
  PA: ["Pennsylvania", ["Philadelphia", "Pittsburgh", "Allentown", "Harrisburg"]],
  RI: ["Rhode Island", ["Providence", "Warwick", "Cranston"]],
  SC: ["South Carolina", ["Charleston", "Columbia", "Greenville", "Myrtle Beach"]],
  SD: ["South Dakota", ["Sioux Falls", "Rapid City", "Aberdeen"]],
  TN: ["Tennessee", ["Nashville", "Memphis", "Knoxville", "Chattanooga"]],
  TX: ["Texas", ["Dallas", "Houston", "Austin", "San Antonio", "Fort Worth", "Frisco", "Plano"]],
  UT: ["Utah", ["Salt Lake City", "Provo", "Ogden", "St. George"]],
  VT: ["Vermont", ["Burlington", "Montpelier", "Rutland"]],
  VA: ["Virginia", ["Virginia Beach", "Richmond", "Arlington", "Norfolk"]],
  WA: ["Washington", ["Seattle", "Bellevue", "Spokane", "Tacoma"]],
  WV: ["West Virginia", ["Charleston", "Huntington", "Morgantown"]],
  WI: ["Wisconsin", ["Milwaukee", "Madison", "Green Bay"]],
  WY: ["Wyoming", ["Cheyenne", "Casper", "Laramie"]],
};

export const stateSlug = (abbr) =>
  abbr === "DC" ? "washington-dc" : STATES[abbr][0].toLowerCase().replace(/ /g, "-");

export const slugToAbbr = Object.fromEntries(Object.keys(STATES).map((a) => [stateSlug(a), a]));

export const regionOf = (abbr) =>
  Object.keys(REGIONS).find((r) => REGIONS[r].includes(abbr));

export const joinNames = (items) =>
  items.length === 1 ? items[0] : items.slice(0, -1).join(", ") + " and " + items[items.length - 1];

export const sortedAbbrs = Object.keys(STATES).sort((a, b) => STATES[a][0].localeCompare(STATES[b][0]));

export function stateObligations(abbr) {
  const name = STATES[abbr][0];
  const items = [
    ["Federal payroll taxes",
      "Federal income tax withholding, Social Security and Medicare, with Form 941 each quarter and Form 940 each year."],
  ];
  if (NO_WAGE_TAX.has(abbr)) {
    items.push(["No state income tax on wages",
      `${name} does not tax wages, so there is no state withholding. We still track employees who live or work in other states and withhold there when required.`]);
  } else {
    items.push([`${name} income tax withholding`,
      `We calculate ${name} withholding from each employee's state form, deposit it on the state's schedule and file the periodic and annual reconciliation returns.`]);
  }
  if (abbr === "TX") {
    items.push(["Texas Workforce Commission unemployment tax",
      "Quarterly wage reports and unemployment tax to the TWC at your assigned rate, including new-employer registration."]);
  } else {
    items.push(["State unemployment insurance",
      `Registration with ${name}'s unemployment agency, quarterly wage reports and contributions at your assigned rate.`]);
  }
  if (LOCAL_TAX.has(abbr)) {
    items.push(["Local taxes",
      `Some cities, counties or school districts in ${name} levy local income, occupational or payroll taxes. We set up local withholding based on where each employee lives and works.`]);
  }
  if (PAID_LEAVE.has(abbr)) {
    items.push(["Paid leave or disability insurance",
      `${name} runs a paid family leave or disability insurance program funded through payroll. We calculate employee and employer shares, withhold where required and file the contributions.`]);
  }
  items.push(["New-hire reporting",
    `Every new or rehired employee is reported to the ${name} new-hire directory within the state's deadline.`]);
  return items;
}

export function stateIntro(abbr) {
  const name = STATES[abbr][0];
  if (abbr === "TX")
    return "ABSLpay is headquartered in Frisco, so Texas payroll is home ground. We work with restaurants, IT firms, contractors and medical practices across the Dallas-Fort Worth area and statewide.";
  if (NO_WAGE_TAX.has(abbr))
    return `Because ${name} has no state income tax on wages, payroll here is simpler than in most states, but federal filings, unemployment insurance and new-hire reporting still apply.`;
  if (LOCAL_TAX.has(abbr) && PAID_LEAVE.has(abbr))
    return `${name} is one of the more involved payroll states, with local taxes and a state paid-leave or disability program on top of state withholding. We keep every layer current.`;
  if (LOCAL_TAX.has(abbr))
    return `Local taxes are where ${name} payroll most often goes wrong. We assign each employee the right local jurisdictions based on home and work addresses.`;
  if (PAID_LEAVE.has(abbr))
    return `${name}'s payroll-funded leave program adds a contribution to every paycheck. We calculate and file it alongside your other state taxes.`;
  return `We handle ${name} withholding, unemployment insurance and new-hire reporting, so you approve payroll and we take care of the filings.`;
}

export function stateFaqs(abbr) {
  const name = STATES[abbr][0];
  const incomeAnswer = NO_WAGE_TAX.has(abbr)
    ? `No. ${name} does not tax wages, so employers do not withhold state income tax. Federal withholding, unemployment insurance and new-hire reporting still apply.`
    : `Yes. Employers withhold ${name} income tax from employee wages and file state returns. ABSLpay calculates, deposits and files it for you.`;
  const qas = [
    [`Does ${name} require state income tax withholding?`, incomeAnswer],
    [`How much does payroll cost in ${name}?`,
      `ABSLpay costs the same in ${name} as in every other state: Essentials is $39 a month plus $5 per person paid, with tax filing and direct deposit included and no per-state surcharge.`],
    [`Can you take over our ${name} payroll in the middle of the year?`,
      "Yes. We import year-to-date wages and tax payments from your current provider, verify the first payroll against your prior figures, and file the full year's W-2s."],
    [`Do you handle ${name} unemployment tax and new-hire reporting?`,
      `Yes. We register or connect your ${name} unemployment account, file quarterly wage reports, pay contributions at your assigned rate and report every new hire to the state.`],
  ];
  if (LOCAL_TAX.has(abbr)) {
    qas.push([`Do you handle local payroll taxes in ${name}?`,
      `Yes. Where ${name} cities, counties or districts levy local income, occupational or payroll taxes, we withhold and file based on each employee's home and work locations.`]);
  }
  return qas;
}
